import { CommonModule, NgClass } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  forwardRef,
  Input,
  input,
  QueryList,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

import { RadioButtonComponent } from './radio-button.component';
import { BaseFormControlComponent } from '../base-form-control/base-form-control';

@Component({
  imports: [CommonModule, FormsModule, NgClass],
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonGroupComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RadioButtonGroupComponent),
    },
  ],
  selector: 'aux-radio-button-group',
  styles: [
    `
      :host ::ng-deep .is-invalid.radio-group input[type='radio'] {
        @apply border-red-500;
      }
    `,
  ],
  template: `
    <fieldset
      class="radio-group flex w-fit"
      [ngClass]="{ 'space-x-4': display() === 'row', 'flex-col space-y-4': display() === 'column' }"
    >
      <ng-content />
    </fieldset>
  `,
})
export class RadioButtonGroupComponent
  extends BaseFormControlComponent<string>
  implements AfterContentInit, ControlValueAccessor
{
  display = input<'column' | 'row'>('row');

  @Input({ required: true }) name!: string;
  @ContentChildren(RadioButtonComponent) radios!: QueryList<RadioButtonComponent>;

  private defaultValue: null | string = null;

  ngAfterContentInit() {
    this.radios.forEach((radio) => {
      radio.name = this.name;

      if (this.defaultValue) {
        radio.setSelectedValue(this.defaultValue);
      }

      radio.onChange = (value: string) => {
        this.selectRadio(value);
      };
    });
  }

  onTouched: () => void = () => {};

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  selectRadio(value: string) {
    this.onChange(value);
    this.onTouched();
  }

  writeValue(value: string): void {
    if (value !== undefined) {
      this.defaultValue = value;

      if (this.radios) {
        this.radios.forEach((radio) => {
          radio.setSelectedValue(value);
        });
      } else {
        this.defaultValue = value;
      }
    }
  }
}
